export const categories = [
  {
    id: "1",
    name: "Ingredients",
    banner:
      "https://www.bakerykart.com/upload/baking-ingredients-for-baking.jpg",
    thumbnail:
      "https://www.bakerykart.com/upload/baking-essentials-thumbnail.jpg",
  },
  {
    id: "2",
    name: "Chocolates",
    banner: "https://www.bakerykart.com/upload/premium-chocolate-mould.jpg",
    thumbnail:
      "https://www.bakerykart.com/upload/chocolate-mould-thumbnail1.jpg",
  },
  {
    id: "3",
    name: "Cake Moulds",
    banner: "https://www.bakerykart.com/upload/cake-mould-banner.jpg",
    thumbnail: "https://www.bakerykart.com/upload/cake-pan-thum-india.jpg",
  },
  {
    id: "4",
    name: "Kitchenware",
    banner: "https://www.bakerykart.com/upload/kitchenware-banner.jpg",
    thumbnail:
      "https://www.bakerykart.com/upload/baking-ingredients-for-baking-design.jpg",
  },
  {
    id: "5",
    name: "Cupcake Liners",
    banner:
      "https://www.bakerykart.com/upload/cup-cake-liners-internal-banners.jpg",
    thumbnail: "https://www.bakerykart.com/upload/cupcake-liners-thumb.jpg",
  },
  {
    id: "6",
    name: "Cake Boxes",
    banner: "https://www.bakerykart.com/upload/cake-boxes-banner.jpg",
    thumbnail: "https://www.bakerykart.com/upload/cake-box-thumbnail.jpg",
  },
  {
    id: "7",
    name: "Decoration & Toppings",
    banner: "https://www.bakerykart.com/upload/display-decor-banner.jpg",
    thumbnail: "https://www.bakerykart.com/upload/sprinkles-thumbnail.jpg",
  },
  {
    id: "8",
    name: "Tools",
    banner: "https://www.bakerykart.com/upload/baking-tools-banner.jpg",
    thumbnail:
      "https://images-na.ssl-images-amazon.com/images/I/41q1MRJn6fL.jpg",
  },
];

export const banners = [
  {
    url: "https://www.bakerykart.com/upload/cake-premix-internal-banner.jpg",
    text: "Buy baking essentials with no distractions",
  },
  {
    url: "https://www.bakerykart.com/upload/internal-default-banner.jpg",
    text: "All year round Discount on select products",
  },
];
